import { render } from "./ASRMpage.vue?vue&type=template&id=7337ec8e&scoped=true"
import script from "./ASRMpage.vue?vue&type=script&lang=js"
export * from "./ASRMpage.vue?vue&type=script&lang=js"

import "./ASRMpage.vue?vue&type=style&index=0&id=7337ec8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7337ec8e"]])

export default __exports__